import { NgModule } from '@angular/core';
import { FlightLogActiveGuard } from '../shared/flight-log-api/flight-logs/flight-log-active.guard';
import { SharedModule } from '../shared/shared.module';
import { AmghFuelTankSelectComponent } from './components/amgh-fuel-tank-select/amgh-fuel-tank-select.component';
import { BillingSummaryComponent } from './components/billing-summary/billing-summary.component';
import { CreateFlightLogPageComponent } from './components/create-flight-log-page/create-flight-log-page.component';
import { DeleteLegConfirmationDialogComponent } from './components/delete-leg-confirmation-dialog/delete-leg-confirmation-dialog.component';
import { EditFlightLogPageComponent } from './components/edit-flight-log-page/edit-flight-log-page.component';
import { EngineMaintenanceOldComponent } from './components/engine-maintenance-simple/engine-maintenance-simple.component';
import { EngineMaintenanceComponent } from './components/engine-maintenance/engine-maintenance.component';
import { FboFuelTankAutocompleteComponent } from './components/fbo-fuel-tank-autocomplete/fbo-fuel-tank-autocomplete.component';
import { FindFlightDialogComponent } from './components/find-flight-dialog/find-flight-dialog.component';
import { FlightCrewMemberSelectComponent } from './components/flight-crew-employee-select/flight-crew-employee-select.component';
import { FlightCrewComponent } from './components/flight-crew/flight-crew.component';
import { FlightLegCrewMemberComponent } from './components/flight-leg-crew-member/flight-leg-crew-member.component';
import { FlightLegComponent } from './components/flight-leg/flight-leg.component';
import { FlightLogComponent } from './components/flight-log-form/flight-log-form.component';
import { FlightLogIndexPageComponent } from './components/flight-log-index-page/flight-log-index-page.component';
import { FuelEventComponent } from './components/fuel-event/fuel-event.component';
import { MaintenanceHookHoistComponent } from './components/maintenance-part133/maintenance-part133.component';
import { MaintenanceSummaryOldComponent } from './components/maintenance-summary-simple/maintenance-summary-simple.component';
import { MaintenanceSummaryComponent } from './components/maintenance-summary/maintenance-summary.component';
import { NewFlightLogDialogComponent } from './components/new-flight-log-dialog/new-flight-log-dialog.component';
import { PilotLogEntryComponent } from './components/pilot-log-entry/pilot-log-entry.component';
import { ResetLegsConfirmationDialogComponent } from './components/reset-legs-confirmation-dialog/reset-legs-confirmation-dialog.component';
import { ViewFlightLogPageComponent } from './components/view-flight-log-page/view-flight-log-page.component';
import { ViewFlightLogSummaryComponent } from './components/view-flight-log-summary/view-flight-log-summary.component';
import { ViewFlightLogComponent } from './components/view-flight-log/view-flight-log.component';

@NgModule({
  imports: [SharedModule],
  declarations: [
    FlightLogComponent,
    FlightLegComponent,
    PilotLogEntryComponent,
    MaintenanceSummaryOldComponent,
    EngineMaintenanceOldComponent,
    DeleteLegConfirmationDialogComponent,
    CreateFlightLogPageComponent,
    EditFlightLogPageComponent,
    ViewFlightLogPageComponent,
    ViewFlightLogComponent,
    FlightLegCrewMemberComponent,
    BillingSummaryComponent,
    FuelEventComponent,
    AmghFuelTankSelectComponent,
    FboFuelTankAutocompleteComponent,
    FlightLogIndexPageComponent,
    ViewFlightLogSummaryComponent,
    FlightCrewComponent,
    FlightCrewMemberSelectComponent,
    NewFlightLogDialogComponent,
    MaintenanceSummaryComponent,
    EngineMaintenanceComponent,
    ResetLegsConfirmationDialogComponent,
    FindFlightDialogComponent,
    MaintenanceHookHoistComponent,
  ],
  entryComponents: [
    ResetLegsConfirmationDialogComponent,
    DeleteLegConfirmationDialogComponent,
    NewFlightLogDialogComponent,
    FindFlightDialogComponent,
  ],
  providers: [FlightLogActiveGuard],
})
export class FlightsModule {}
